




























































import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import { Constants } from '../fixed/Constants';
@Component
export default class VariableInput extends Vue {
  private validate = require('../../CommonUtils/fixed/Validate'); // Validate
  private privateInvaildMessage: string = '';
  private innerLabel: string = '';
  private rules: any;
  private clearable: boolean = false;
  private counter: string | boolean = false;
  private privateTextColor: string = '';
  private dummyValue = '';
  // 2023.07.04 [2023F-05] add start
  private isPassword: boolean = false;
  private isPasswordShow: boolean = false;
  // 2023.07.04 [2023F-05] add end
  // (ts)親コンポーネントからデータを受け取るpropsは@Propデコレータ
  @Prop({default: false}) private isGroup?: boolean;
  @Prop() private grouplabel?: string;
  @Prop() private groupLayout?: string;
  @Prop() private label?: string;
  @Prop() private type?: string;
  @Prop() private name!: string;
  @Prop() private value?: string;
  @Prop({default: false}) private readonly?: boolean;
  @Prop({default: false}) private disabled?: boolean;
  @Prop({default: false}) private required?: boolean;
  @Prop() private prefix?: string;
  @Prop() private suffix?: string;
  @Prop() private placeholder?: string;
  @Prop() private hint?: string;
  @Prop() private size?: string;
  @Prop() private maxlength?: string;
  @Prop() private minlength?: string;
  @Prop() private pattern?: string;
  @Prop() private invaildMessage?: string;
  @Prop() private textColor?: string;
  // (ts)親コンポーネントに値を送信する$emitは@Emitデコレータを使いfunctionとして定義
  @Emit('input')
  private updateValue(value: string) {
    if (value === null) {
      value = '';
    }
    return value;
  }
  private created() {
    // 確認画面表示のdefault文字色設定
    if (!this.textColor) {
      this.privateTextColor = 'black--text';
    } else {
      this.privateTextColor = this.textColor;
    }
    // ラベルの設定
    if (this.isGroup && this.label && this.groupLayout !== Constants.GROUP_LAYOUT_ARRAY) {
      this.innerLabel = this.label;
    }
    // クリアボタンの設定
    this.clearable = !(this.readonly || this.disabled);
    if (this.invaildMessage) {
      this.privateInvaildMessage = this.invaildMessage;
    }
    // validationルールの設定
    this.rules = [
      (value: string) => (this.isValidateRequired(value)) || '必須項目です。',
      (value: string) => (this.isValidate(value)) || this.privateInvaildMessage,
      ];
    // 文字数カウンタの設定
    if (this.maxlength) {
      this.counter = this.maxlength;
    }
    // ダミー値の設定
    if (this.disabled && !this.value) {
      this.dummyValue = '　';
    }
    // 2023.07.04 [2023F-05] add start
    // パスワード入力の設定
    if (this.type === 'password') {
      this.isPassword = true;
    }
    // 2023.07.04 [2023F-05] add end
  }
  // validationの設定
  private isValidateRequired(value: string) {
    return this.validate.isValidateRequired(value, this.required);
  }
  private isValidate(value: string) {
    return this.validate.isValidate(value, this.maxlength, this.minlength, this.pattern);
  }
}
